<template>
  <div>
    <b-form-group
      label-for="input-statement"
      label-cols-sm="4"
      label-cols-lg="2"
      label="지시문"
    >
      <b-form-input
        :class="statement_valid_cls"
        id="input-statement"
        v-model="statement"
      ></b-form-input>
    </b-form-group>

    <!-- 서답형 -->

    <div class="gray100" v-if="qtype == '3'">
      <b-form-group label="추가문제유형">
        <b-form-radio-group
          v-model="q_type_sub"
          :options="q_type_sub_options"
          name="radio-s-type"
        ></b-form-radio-group>
      </b-form-group>
    </div>

    <div :class="title_valid_cls">
      <div>{{ qdesc }}</div>
      <Editor
        ref="editor1"
        v-on:processing="appendAnswer"
        v-on:processing2="appendQType2Answer"
        v-on:processing3="appendQType3Answer"
        v-on:processing4="appendQType4Answer"
        func="updateQTitle"
        :content="title"
      />
    </div>
    <div v-if="qtype == '1'">
      <QType1Answer
        :answer="answer"
        v-bind:key="answer.id"
        v-for="answer in answers"
      />
      <b-row :class="nocount_qtype1_valid_cls">
        <b-col>
          <b-form-group>
            <b-button block size="sm" @click="appendAnswer('')">
              정답추가(+)
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <div :class="intent1_valid_cls">
        <b-row>
          <b-col>출제포인트*</b-col>
        </b-row>
        <div class="multisel_wrapper bspace">
          <multiselect
            v-model="intent1"
            :options="intent_options"
            :custom-label="nameWithLang"
            placeholder="출제포인트1(필수)"
            label="name"
            track-by="name"
          ></multiselect>
        </div>
        <div class="multisel_wrapper bspace">
          <multiselect
            v-model="intent2"
            :options="intent_options"
            :custom-label="nameWithLang"
            placeholder="출제포인트2"
            label="name"
            track-by="name"
          ></multiselect>
        </div>
        <div class="multisel_wrapper bspace">
          <multiselect
            v-model="intent3"
            :options="intent_options"
            :custom-label="nameWithLang"
            placeholder="출제포인트3"
            label="name"
            track-by="name"
          ></multiselect>
        </div>
      </div>
    </div>
    <div v-if="qtype == '2'">
      <QType2Answer />
    </div>

    <div v-if="qtype == '3'">
      <QType3Answer />
    </div>

    <div v-if="qtype == '4'">
      <QType4Answer />
    </div>
    <div v-if="qtype == '5'">
      <QType5Answer />
    </div>

    <div>해석</div>
    <NormalEditor
      key="ned_1"
      ref="editor2"
      :content="translate"
      func="updateTranslate"
    />

    <div>해설</div>
    <NormalEditor
      key="ned_2"
      ref="editor3"
      :content="qcomment"
      func="updateQComment"
    />

    <b-row class="imagepanel">
      <b-col>
        <FileUpload utype="image" fileobj="image" v-if="image == ''" />
        <div v-else>
          <div>이미지</div>
          <div class="file-result">
            <img :src="image" class="preview" />
            <b-button size="sm" variant="danger" @click="removeimg()"
              >삭제</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <VideoForm :video="video" :key="video.id" v-for="video in videos" />
    <b-row>
      <b-col>
        <b-form-group>
          <b-button block size="sm" @click="appendVideo">
            동영상추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <FileUpload utype="sound" fileobj="sound" v-if="sound == ''" />

        <div v-else>
          <div>사운드</div>
          <div class="file-result">
            {{ sound }}
            <b-button size="sm" variant="danger" @click="removesnd()"
              >삭제</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <LevelForm />

    <b-row>
      <b-col sm="6" lg="6" v-show="1 == 2">
        <b-form-group
          label="어휘레벨:"
          label-cols-sm="3"
          label-cols-lg="2"
          label-for="input-wordlevel"
        >
          <b-form-select
            id="input-wordlevel"
            v-model="word_level"
            :options="word_level_options"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="기출정보:"
          label-cols-sm="3"
          label-cols-lg="2"
          label-for="input-previnfo"
        >
          <b-form-input id="input-previnfo" v-model="prevtest_info" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-button @click="binddic()" v-show="1 == 2">레벨체크</b-button>

    <b-row>
      <b-col class="button_wrapper">
        <b-button @click="save" variant="primary" class="float-right">{{
          saveorupdate_title
        }}</b-button>
        <b-button @click="cancel" variant="danger" class="float-right"
          >취소</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import NormalEditor from "@/components/NormalEditor";
import Editor from "@/components/Editor";
import QType1Answer from "@/components/question/QType1Answer";
import QType2Answer from "@/components/question/QType2Answer";
import QType3Answer from "@/components/question/QType3Answer";
import QType4Answer from "@/components/question/QType4Answer";
import QType5Answer from "@/components/question/QType5Answer";
import FileUpload from "@/components/FileUpload";
import VideoForm from "@/components/question/VideoForm";
import LevelForm from "@/components/question/LevelForm";
import Multiselect from "vue-multiselect";

import axios from "axios";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

export default {
  components: {
    Editor,
    QType1Answer,
    QType2Answer,
    QType3Answer,
    QType4Answer,
    QType5Answer,
    NormalEditor,
    FileUpload,
    VideoForm,
    LevelForm,
    Multiselect,
  },
  mounted() {
    // alert("mounted");
    if (this.$store.state.questionmeta.id == "") {
      this.$refs.editor1.reset();
      this.$refs.editor2.reset();
      this.$refs.editor3.reset();
    }
  },

  data() {
    return {
      imsi: "hello owlrd",
      myp: "",
      intentx: "",
    };
  },
  watch: {
    metaid(to, from) {
      if (to == "") {
        this.$refs.editor1.reset();
        this.$refs.editor2.reset();
        this.$refs.editor3.reset();
      }
      console.log(to);
    },
  },

  computed: {
    word_level_options() {
      return this.$store.state.word_level_options;
    },
    word_level: {
      get() {
        return this.$store.state.questionform.word_level;
      },
      set(val) {
        this.$store.commit("updateWordLevel", val);
      },
    },

    nocount_qtype1_valid_cls() {
      return this.$store.state.valid.qtype1_nocount;
    },

    intent1: {
      set(val) {
        this.$store.commit("updateIntent1", val);
      },
      get() {
        return this.$store.state.questionform.intent1;
      },
    },

    intent2: {
      set(val) {
        this.$store.commit("updateIntent2", val);
      },
      get() {
        return this.$store.state.questionform.intent2;
      },
    },
    intent3: {
      set(val) {
        this.$store.commit("updateIntent3", val);
      },
      get() {
        return this.$store.state.questionform.intent3;
      },
    },

    intent_options() {
      return this.$store.state.intent_options;
    },
    intent1_valid_cls() {
      return this.$store.state.valid.intent1;
    },

    metaid() {
      return this.$store.state.questionmeta.id;
    },
    q_type_sub: {
      get() {
        return this.$store.state.questionform.q_type_sub;
      },
      set(val) {
        this.$store.commit("updateQTypeSub", val);
      },
    },
    q_type_sub_options() {
      return this.$store.state.q_type_sub_options;
    },
    qtype() {
      return this.$store.state.questionform.q_type;
    },

    qdesc() {
      return this.qtype == "5" ? "지문(선택보기용)" : "문제 *";
    },

    qid() {
      return this.$store.state.questionform.id;
    },

    saveorupdate_title() {
      return this.qid == "" ? "저장" : "수정";
      // return "저장";
    },
    title() {
      return this.$store.state.questionform.title_imsi;
    },
    statement_valid_cls() {
      return this.$store.state.valid.statement;
    },
    title_valid_cls() {
      return this.$store.state.valid.title;
    },

    questionmeta() {
      return this.$store.state.questionmeta;
    },
    questionform() {
      return this.$store.state.questionform;
    },
    qtype1_answers() {
      return this.$store.state.qtype1_answers;
    },

    prevtest_info: {
      get() {
        return this.$store.state.questionform.prevtest_info;
      },
      set(val) {
        this.$store.commit("updatePrevtestInfo", val);
      },
    },

    statement: {
      get() {
        return this.$store.state.questionmeta.statement;
      },
      set(val) {
        this.$store.commit("updateStatement", val);
      },
    },
    answers() {
      return this.$store.state.qtype1_answers;
    },
    translate() {
      return this.$store.state.questionmeta.translate_imsi;
    },
    qcomment() {
      return this.$store.state.questionmeta.qcomment_imsi;
    },
    videos() {
      return this.$store.state.questionform.videos;
    },
    image() {
      return this.$store.state.questionform.image;
    },
    sound() {
      return this.$store.state.questionform.sound;
    },
  },
  methods: {
    async binddic() {
      let title = this.$store.state.questionform.title;
      title = title.replace(/<[^>]*>?/gm, "");
      let titles = title.split(" ");

      let flevel = 3;
      for (let i = 0; i < titles.length; i++) {
        if (titles[i] != "") {
          console.log(titles[i]);
          let url = `${SERVER_URL}/query?q=${titles[i]}`;
          await axios.get(url).then((resp) => {
            let data = resp.data;
            let klvl = 0;
            console.log(data.status);
            if (data.status.indexOf("ico_star1") >= 0) {
              klvl = 1;
            } else if (data.status.indexOf("ico_star2") >= 0) {
              klvl = 2;
            } else if (data.status.indexOf("ico_star3") >= 0) {
              klvl = 3;
            } else {
              console.log("catch here");
              klvl = 0;
            }
            if (flevel > klvl) {
              flevel = klvl;
            }
          });
        }
      }

      this.word_level = flevel + "";
      alert("레벨체크 완료");
    },

    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },

    appendAnswer(seltext) {
      this.$store.dispatch("appendQType1Answer", seltext);
    },
    appendQType2Answer(seltext) {
      this.$store.dispatch("appendQType2Pick", seltext);
    },
    appendQType3Answer(seltext) {
      this.$store.dispatch("appendQType3Pick", seltext);
    },
    appendQType4Answer(seltext) {},

    appendVideo() {
      this.$store.dispatch("appendVideo");
    },

    appendIntent() {
      this.$store.dispatch("appendIntent");
    },

    async save() {
      let _k = await this.$store.dispatch("saveQType1");

      if (!_k) {
        alert("폼을 확인해주세요");
        return false;
      }
      // this.$store.commit("updateDebug", "리턴이후 실행");
      this.$nextTick(() => {
        this.$refs.editor1.reset();
        this.$refs.editor2.reset();
        this.$refs.editor3.reset();
      });
    },
    cancel() {
      this.$refs.editor1.reset();
      this.$refs.editor2.reset();
      this.$refs.editor3.reset();
      this.$store.commit("resetQuestionForm");
      this.$store.commit("resetQuestionMeta");
    },
    removeimg() {
      this.$store.commit("updateImage", "");
    },
    removesnd() {
      this.$store.commit("updateSound", "");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.invalid {
  border: 2px solid red;
}

.button_wrapper {
  button {
    margin-right: 5px;
  }
}

.imagepanel {
  margin-bottom: 20px;
  margin-top: 20px;

  .file-result {
    display: flex;
    align-items: flex-end;

    .preview {
      max-height: 100px;
    }
  }
}

.gray100 {
  background-color: $gray200;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.bspace {
  margin-bottom: 10px;
}
</style>